import { defineComponent } from 'vue';
import { Back } from '@element-plus/icons-vue';

const icons = {
  Back,
};

export default defineComponent({
  name: 'SettingsPageHeader',
  props: {
    isShowBackButton: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['backButtonPressed'],
  setup(_props, { emit }) {
    const goBack = () => {
      emit('backButtonPressed');
    };

    return {
      icons,
      goBack,
    };
  },
});
